import {type VtkStateRef} from '@/types';

import {useSetColorScheme, useSetOpacity, useSetThreshold} from './hooks';

export default function useSetDensityMap({vtkState}: {vtkState: VtkStateRef}) {
	useSetColorScheme({vtkState});
	useSetOpacity({vtkState});
	useSetThreshold();
}
